import { PaymentPeriod } from "@nf/common";

export const PERIOD_LABEL: Record<PaymentPeriod, string> = {
  [PaymentPeriod.Month]: "web_landing_page_offer_monthly",
  [PaymentPeriod.HalfYear]: "web_subscription_6months",
  [PaymentPeriod.Year]: "web_landing_page_offer_annual",
};
